module.exports = __webpack_public_path__ + "img/icon_文件列表_空白@2x.b5102b93.png";